import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Isvg from 'react-inlinesvg';
import { Link } from 'react-router-dom';
import iconEmail from '../../sass/icons/icon-email.svg';
import iconFacebook from '../../sass/icons/icon-facebook-f.svg';
import iconLinkedIn from '../../sass/icons/icon-linkedin.svg';
import iconTel from '../../sass/icons/icon-tel.svg';
import iconTwitter from '../../sass/icons/icon-twitter.svg';
import wololo from '../../sass/icons/wololo-logo.svg';
import portoLogo from '../../sass/images/portodigital.png';
import './Footer.scss';
import IconList from './IconList';



const icons = [
  {
    src: iconTel,
    url: 'tel:‭+558130346132‬'
  },
  {
    src: iconFacebook,
    url: 'https://www.facebook.com/wololotech/'
  },
  {
    src: iconLinkedIn,
    url: 'https://pt.linkedin.com/company/wololo---we-convert'
  },
  {
    src: iconTwitter,
    url: 'https://www.twitter.com/wololotech/'
  },
  // {
  //   src: iconWhatsapp,
  //   url: 'https://www.facebook.com/wololotech/'
  // },
  {
    src: iconEmail,
    url: 'mailto:contato@talkative.media'
  }
]

class Footer extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  }
  render() {
    const year = new Date().getFullYear()
    return (
      <footer className="site-footer">
        <div className="content">
          <div className="container">
            <div className="grid lower">
              <div className="col-4_xs-12 logo">
                <Isvg src={wololo} />
                <div>
                  <p>{this.context.t('Núcleo de Desenvolvimento', {}, 'Texto no rodapé')}</p>
                  <address>
                    {this.context.t('Rua do Apolo, 181, Sala 203 - Recife Antigo', {}, 'Texto no rodapé')} <br/>
                    {this.context.t('Recife, PE — Brasil • CEP 50030-220', {}, 'Texto no rodapé')}
                  </address>
                </div>
              </div>
              <div className="col-7_xs-12 grid links-container" data-push-left="off-1_xs-0">
                <div className="col-3_xs-12">
                  <h6>{this.context.t('Empresa', {}, 'Texto no rodapé')}</h6>
                  <ul>
                    <li>
                      <Link to={this.context.t('/sobre', {}, 'Rota para /sobre')}>
                        {this.context.t('Sobre nós', {}, 'Texto no rodapé')}
                      </Link>
                    </li>
                    <li>
                      <Link to={this.context.t('/checkout', {}, 'Rota para /checkout')}>
                          {this.context.t('Preço')}
                      </Link>
                    </li>
                    <li>
                      <Link to={this.context.t('/artigos', {}, 'Rota para /artigos')}>
                          {this.context.t('Artigos')}
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="col-3_xs-12">
                  <h6>{this.context.t('Cases', {}, 'Texto no rodapé')}</h6>
                  <ul>
                    <li>
                      <Link to={this.context.t('/pequeno-negocio', {}, 'Rota para /pequeno-negocio')}>
                        {this.context.t('Pequeno negócio', {}, 'Texto no rodapé')}
                      </Link>
                    </li>
                    <li>
                      <Link to={this.context.t('/grande-empresa', {}, 'Rota para /grande-empresa')}>
                        {this.context.t('Grande empresa', {}, 'Texto no rodapé')}
                      </Link>
                    </li>
                    <li>
                      <Link to={this.context.t('/politica', {}, 'Rota para /politica')}>
                        {this.context.t('Política', {}, 'Texto no rodapé')}
                      </Link>
                    </li>
                    <li>
                      <Link to={this.context.t('/personalidade', {}, 'Rota para /personalidade')}>
                        {this.context.t('Personalidade', {}, 'Texto no rodapé')}
                      </Link>
                    </li>
                    <li>
                      <Link to={this.context.t('/endomarketing', {}, 'Rota para /endomarketing')}>
                        {this.context.t('Endomarketing', {}, 'Texto no rodapé')}
                      </Link>
                    </li>
                    <li>
                      <Link to={this.context.t('/causa', {}, 'Rota para /causa')}>
                        {this.context.t('Causa', {}, 'Texto no rodapé')}
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="col-3_xs-12">
                  <h6>{this.context.t('Suporte', {}, 'Texto no rodapé')}</h6>
                  <ul>
                    <li>
                      <a href="https://suporte.talkative.media/" target="_blank" rel="noopener noreferrer">
                        {this.context.t('Central de ajuda', {}, 'Texto no rodapé')}
                      </a>
                    </li>
                    <li>
                      <Link to={this.context.t('/termos', {}, 'Rota para /termos')}>
                        {this.context.t('Termos de Uso', {}, 'Texto no rodapé')}
                      </Link>
                    </li>
                    <li>
                      <Link to={this.context.t('/devolucao', {}, 'Rota para /devolucao')}>
                        {this.context.t('Devolução', {}, 'Texto no rodapé')}
                      </Link>
                    </li>
                    <li>
                      <Link to={this.context.t('/contato', {}, 'Rota para /contato')}>
                        {this.context.t('Contato', {}, 'Texto no rodapé')}
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="col-3_xs-12">
                  <h6>{this.context.t('Mais', {}, 'Texto no rodapé')}</h6>
                  <ul>
                    <li>
                      <a href="https://pt.linkedin.com/company/wololo---we-convert" target="_blank" rel="noopener noreferrer">
                        {this.context.t('Linkedin', {}, 'Texto no rodapé')}
                      </a>
                    </li>
                    <li>
                      <a href="https://www.facebook.com/wololotech/" target="_blank" rel="noopener noreferrer">
                        {this.context.t('Facebook', {}, 'Texto no rodapé')}
                      </a>
                    </li>
                    <li>
                    <a href="https://www.twitter.com/wololotech/" target="_blank" rel="noopener noreferrer">
                        {this.context.t('Twitter', {}, 'Texto no rodapé')}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="social-links_footer">
          <div className="container">
            <div className="grid-spaceBetween">
              <div className="col-3_xs-12 grid-spaceBetween about">
                <IconList icons={icons} />
              </div>
              <div className="col-6_xs-12">
                <p className="copyright">
                  ©{year} Wololo
                  <span>
                    {this.context.t(' — Todos os Direitos Reservados', {}, 'Texto no rodapé')}
                  </span>
                </p>
              </div>
              <div className="col-3_xs-12 porto-container">
                <img src={portoLogo} alt={this.context.t('Porto Digital', {}, 'Texto no rodapé')}/>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js